import React, { ReactElement } from 'react';

import { PublicPage } from 'api/website';
import { Box } from 'components/Box';
import { StaffTools } from 'components/Staff/StaffTools';
import { useCurrentUserIsStaff } from 'store/main/hooks/useCurrentUserIsStaff';
import { gutterWidth } from 'theme';

type Props = {
  content: PublicPage;
};

export function FixedLayoutStaffTools({ content }: Props): ReactElement | null {
  const isStaff = useCurrentUserIsStaff();
  if (!isStaff) return null;

  return (
    <Box
      position="fixed"
      zIndex={102}
      top={[60 + gutterWidth / 2, null, null, 190]}
      right={gutterWidth / 2}
    >
      <StaffTools content={content} />
    </Box>
  );
}
